<script setup>
import { onMounted } from "vue";

const props = defineProps({
  LoteStore: Object,
  usuarioStore: Object
});

const isLogged = props.usuarioStore.isLogged;
const lote = props.LoteStore.lote;
const aceptoTerminos = props.LoteStore.aceptoTerminos;

onMounted(() => {
  if (!lote.subasta.termino_condicion.archivo) {
    lote.subasta.termino_condicion.archivo = {
      archivo: null,
      entidad: "subasta",
      filename: null,
      hash: null,
      extension: "pdf",
      tipo_archivo_id: 8,
      vista_previa: null,
    };
  }

  lote.subasta.termino_condicion.archivo.vista_previa = lote.subasta.termino_condicion
    .archivo.hash
    ? `${process.env.VUE_APP_STORAGE_URL}/${lote.subasta.termino_condicion.archivo.hash}.pdf`
    : null;
});


async function aceptarTerminosCheck() {
  await props.LoteStore.aceptarTerminosCondiciones(props.LoteStore.lote.subasta_id);
  await props.LoteStore.obtenerAceptoTerminos(props.LoteStore.lote.subasta_id);
}
</script>

<template>
  <div class="card shadow-sm p-4">
    <div class="col-md-12 p-2 mt-3" v-if="
      lote.subasta.termino_condicion.archivo &&
      lote.subasta.termino_condicion.archivo.vista_previa
    ">
      <iframe :src="lote.subasta.termino_condicion.archivo.vista_previa" width="100%" height="500px"></iframe>

      <div class="form-check mt-3" v-if="!aceptoTerminos && isLogged">
        <input class="form-check-input" type="checkbox" v-model="aceptoTerminos" @change="aceptarTerminosCheck" />
        <label class="form-check-label">
          Aceptar Términos y Condiciones
        </label>
      </div>
    </div>

  </div>
</template>